import {
  Grid,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  Paper,
  TableBody,
} from '@mui/material';

import { Chip } from '../../../components/common';
import {
  TableRow as StyledTableRow,
  TableCell as StyledTableCell,
} from '../../../components/common/Table';
import { downloadBase64Attachment } from '../../../utils/utils';

export default function AnimalProductionTable(props) {
  let animalProductionIncomeSum = 0;
  props.data?.forEach((row) => (animalProductionIncomeSum += row.incomeValue));

  return (
    <>
      <Grid container sx={{ mt: 4 }}>
        <Grid item xs={12} ref={props.cropsStructureTableRef}>
          <TableContainer component={Paper}>
            <Table sx={{ minWidth: 700 }} aria-label="animalProductionTable">
              <TableHead>
                <TableRow>
                  <StyledTableCell>Nazwa produkcji zwierzęcej</StyledTableCell>
                  <StyledTableCell align="center">Ilość (szt.)</StyledTableCell>
                  <StyledTableCell align="center">
                    Szacowany roczny dochód (zł)
                  </StyledTableCell>
                  <StyledTableCell align="center">% Dochodu</StyledTableCell>
                  <StyledTableCell align="center">Załączniki</StyledTableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {props.data
                  ?.sort((a, b) => a.id - b.id)
                  .map((row) => (
                    <StyledTableRow
                      key={
                        row.incomeName +
                        row.livestockAmount +
                        '_animal_production'
                      }
                    >
                      <StyledTableCell component="th" scope="row">
                        {row.incomeName}
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        {row.livestockAmount}
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        {row.incomeValue}
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        {Number((row.percentageOfIncome * 100).toFixed(2))}
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        {row.file !== null && (
                          <Chip
                            label={row.fileName}
                            onClick={() =>
                              downloadBase64Attachment(
                                row.file,
                                row.fileExtension,
                                row.fileName
                              )
                            }
                          />
                        )}
                      </StyledTableCell>
                    </StyledTableRow>
                  ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>
        <Grid
          item
          xs={12}
          container
          justifyContent="right"
          alignContent="right"
        >
          <Grid item xs={6} sx={{ my: 4, minWidth: 230 }}>
            <TableContainer>
              <Table sx={{ width: '100%' }}>
                <TableHead>
                  <TableRow
                    style={{ boxShadow: '0px 1px 18px rgba(0, 0, 0, 0.12)' }}
                  >
                    <StyledTableCell
                      variant="head"
                      style={{
                        borderRadius: '6px 0px 0px 6px',
                        width: '70%',
                      }}
                    >
                      Sumaryczny roczny dochód z produkcji zwierzęcej (zł)
                    </StyledTableCell>
                    <StyledTableCell
                      style={{
                        borderRadius: '0px 6px 6px 0px',
                        width: '30%',
                        backgroundColor: 'rgba(0, 0, 0, 0.04)',
                        color: '#000000',
                      }}
                    >
                      {animalProductionIncomeSum || ''}
                    </StyledTableCell>
                  </TableRow>
                </TableHead>
              </Table>
            </TableContainer>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
}
